function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center p-12">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#FDCB12]"></div>
    </div>
  );
}

export default LoadingSpinner;